import api from '../../../core/api/client';

export const clientService = {
  async getAllClients() {
    const res = await api.get('/clients');
    return Array.isArray(res.data) ? res.data : (res.data?.clients ?? []);
  },

  async getClientByUserId(userId) {
    const res = await api.get(`/clients/users/${encodeURIComponent(userId)}`);
    return res.data;
  },

  // POST upserts by user_id — creates if none exists, merges otherwise
  async createOrUpdateClient(payload) {
    const res = await api.post('/clients', payload);
    return res.data;
  },

  async updateClient(clientId, updates) {
    const res = await api.patch(`/clients/${encodeURIComponent(clientId)}`, updates);
    return res.data;
  },

  async deleteClient(clientId) {
    const res = await api.delete(`/clients/${encodeURIComponent(clientId)}`);
    return res.data;
  },

  // PUT — replaces the entire project_ids array
  async replaceClientProjects(userId, projectIds) {
    const res = await api.put(`/clients/users/${encodeURIComponent(userId)}/projects`, { project_ids: projectIds });
    return res.data;
  },
};
